// extracted by mini-css-extract-plugin
export default {"headerText":"QuestionExplanation_headerText__Api9I","explanationText":"QuestionExplanation_explanationText__uOVy4"};